(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lynktr-an4eq-dialogs-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dialog = document.getElementById('info-certificate');
  const zoom = document.getElementById('certificate-zoom');
  const viewport = document.getElementById('certificate-viewport');
  if (!dialog || !zoom || !viewport) return;
  const reset = () => {
    viewport.classList.remove('is-zoomed');
    zoom.setAttribute('aria-pressed', 'false');
    zoom.textContent = 'Zoom in';
    viewport.scrollTop = 0;
    viewport.scrollLeft = 0;
  };
  zoom.addEventListener('click', () => {
    const enlarged = viewport.classList.toggle('is-zoomed');
    zoom.setAttribute('aria-pressed', String(enlarged));
    zoom.textContent = enlarged ? 'Zoom out' : 'Zoom in';
  });
  dialog.addEventListener('close', reset);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lynktr-hq16sel-dialogs-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dialog = document.getElementById('info-certificate');
  const zoom = document.getElementById('certificate-zoom');
  const viewport = document.getElementById('certificate-viewport');
  if (!dialog || !zoom || !viewport) return;
  const reset = () => {
    viewport.classList.remove('is-zoomed');
    zoom.setAttribute('aria-pressed', 'false');
    zoom.textContent = 'Zoom in';
    viewport.scrollTop = 0;
    viewport.scrollLeft = 0;
  };
  zoom.addEventListener('click', () => {
    const enlarged = viewport.classList.toggle('is-zoomed');
    zoom.setAttribute('aria-pressed', String(enlarged));
    zoom.textContent = enlarged ? 'Zoom out' : 'Zoom in';
  });
  dialog.addEventListener('close', reset);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lynktr-hq4rev-dialogs-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dialog = document.getElementById('info-certificate');
  const zoom = document.getElementById('certificate-zoom');
  const viewport = document.getElementById('certificate-viewport');
  if (!dialog || !zoom || !viewport) return;
  const reset = () => {
    viewport.classList.remove('is-zoomed');
    zoom.setAttribute('aria-pressed', 'false');
    zoom.textContent = 'Zoom in';
    viewport.scrollTop = 0;
    viewport.scrollLeft = 0;
  };
  zoom.addEventListener('click', () => {
    const enlarged = viewport.classList.toggle('is-zoomed');
    zoom.setAttribute('aria-pressed', String(enlarged));
    zoom.textContent = enlarged ? 'Zoom out' : 'Zoom in';
  });
  dialog.addEventListener('close', reset);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lynktr-hq8sel-dialogs-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dialog = document.getElementById('info-certificate');
  const zoom = document.getElementById('certificate-zoom');
  const viewport = document.getElementById('certificate-viewport');
  if (!dialog || !zoom || !viewport) return;
  const reset = () => {
    viewport.classList.remove('is-zoomed');
    zoom.setAttribute('aria-pressed', 'false');
    zoom.textContent = 'Zoom in';
    viewport.scrollTop = 0;
    viewport.scrollLeft = 0;
  };
  zoom.addEventListener('click', () => {
    const enlarged = viewport.classList.toggle('is-zoomed');
    zoom.setAttribute('aria-pressed', String(enlarged));
    zoom.textContent = enlarged ? 'Zoom out' : 'Zoom in';
  });
  dialog.addEventListener('close', reset);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lynktr-survey-page-route"] && !Shopify.designMode) return;
  try {
    
  function initialiseSurveyPageRoute(root) {
    root.querySelectorAll('.lynktr-survey-route').forEach((section) => {
      if (section.dataset.surveyRouteInitialised === 'true') return;

      const appHost = section.querySelector('.lynktr-survey-route__app');
      const formCard = section.querySelector('.ss-form-card');
      if (!appHost || !formCard) return;

      section.dataset.surveyRouteInitialised = 'true';

      const syncRoute = () => {
        const formsRoot = appHost.querySelector('[data-form-root="true"][data-forms-id^="forms-root-"]');
        const renderedFormsUi = appHost.querySelector('form, iframe, shopify-forms-embed');
        const populatedFormsRoot = formsRoot && (
          formsRoot.childElementCount > 0 ||
          formsRoot.textContent.trim().length > 0 ||
          (formsRoot.shadowRoot && formsRoot.shadowRoot.childElementCount > 0)
        );
        const isActive = Boolean(renderedFormsUi || populatedFormsRoot);

        if (appHost.parentElement !== formCard) formCard.appendChild(appHost);
        appHost.hidden = !isActive;
        section.classList.toggle('lynktr-survey-route--app-active', isActive);
      };

      syncRoute();
      new MutationObserver(syncRoute).observe(appHost, {
        childList: true,
        subtree: true
      });

      let checksRemaining = 30;
      const readinessTimer = window.setInterval(() => {
        syncRoute();
        checksRemaining -= 1;
        if (checksRemaining <= 0 || section.classList.contains('lynktr-survey-route--app-active')) {
          window.clearInterval(readinessTimer);
        }
      }, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseSurveyPageRoute(document));
  } else {
    initialiseSurveyPageRoute(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseSurveyPageRoute(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
